import axios from 'axios'
import config from '../../config'
import wrapper from "axios-cache-plugin";


let foodCache = wrapper(axios, {
  maxCacheSize: Infinity
});


foodCache.__addFilter(/recipes/);

export default {
  CancelToken: axios.CancelToken,
  CancelRequests: null,
  deleteReviewComment(id) {
    return axios.delete(config.apiUrl + 'recipes/reviews/comments/' + id)
  },
  postReviewComment(reviewId, data) {
    return axios.post(config.apiUrl + 'recipes/reviews/' + reviewId + '/comments', data)
  },
  deleteMealPlan(id) {
    return axios.delete(config.apiUrl + 'recipes/mealplans/' + id);
  },
  getMealPlanById(id) {
    return axios.get(config.apiUrl + 'recipes/mealplans/get/' + id)
  },
  getMealPlans(page = 0, limit = 25) {
    return axios.get(config.apiUrl + 'recipes/mealplans/me', {
      params: {
        page: page,
        limit: limit
      }
    })
  },
  addMealPlan(model) {
    return axios.post(config.apiUrl + 'recipes/mealplan/create', model);
  },
  addToFoodDiary(model) {
    return axios.post(config.apiUrl + 'recipes/addToFoodDiary', model)
  },
  notingroup(suitabilities, dietaryTypes) {
    return axios.get(config.apiUrl + 'recipes/notingroup?suitabilities=' + suitabilities + '&dietaryTypes=' + dietaryTypes);
  },
  notingroupQuery(query) {
    return axios.get(config.apiUrl + 'recipes/notingroup', {
      params: query
    });
  },
  getFavorites() {
    return foodCache({url: config.apiUrl + 'recipes/favorites/', method: 'GET'})
  },
  favorite(recipeId) {
    return axios.post(config.apiUrl + 'recipes/favorite/', {
      recipeId: recipeId
    })
  },
  deleteReview(reviewId) {
    return axios.delete(config.apiUrl + 'recipes/review/' + reviewId)
  },
  reviews(recipeId, params) {
    return axios.get(config.apiUrl + 'recipes/' + recipeId + '/reviews/', {
      params: params
    })
  },
  review(model) {
    return axios.post(config.apiUrl + 'recipes/review/', model);
  },
  rate(model) {
    return axios.post(config.apiUrl + 'recipes/rating/', model);
  },
  search(filter) {
    let self = this;
    return axios.get(config.apiUrl + 'recipes/search/',
      {
        params: filter,
        cancelToken: new self.CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          self.CancelRequests = c;
        })
      })
  },
  group(filter) {
    return axios.get(config.apiUrl + 'recipes/bygroup/', {params: filter})
  },
  getById(id) {
    return axios.get(config.apiUrl + 'recipes/' + id);
  },
  updateReviewComment(commentId, data) {
    return axios.put(`${config.apiUrl}recipes/reviews/comments/${commentId}`, data)
  },
  updateReview(reviewId, model) {
    return axios.put(`${config.apiUrl}recipes/review/${reviewId}/`, model);
  },
}



// WEBPACK FOOTER //
// ./src/api/Recipes/index.js